import { getAccess } from '../../API/Access';

const STORAGE_KEY = 'app_access';

const getStoredAccess = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  } catch (e) {
    return null;
  }
};

const hasAccess = (access, needs, type) =>
  !!(
    type &&
    needs.length === 2 &&
    typeof access?.[type] !== 'undefined' &&
    typeof access?.[type]?.[needs[0]] !== 'undefined' &&
    access?.[type]?.[needs[0]]?.includes(needs[1])
  );

const getSchoolAccess = (school, type) => {
  if (!school || typeof school !== 'object') {
    return null;
  }
  if (school.access) {
    return school.access?.[type] ?? school.access;
  }
  return null;
};

export default {
  namespaced: true,
  mutations: {
    SET_SERVER_ACCESS(state, payload) {
      state.serverAccess = payload;
      if (payload) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    },
    RESET_STATE(state) {
      state.serverAccess = null;
      localStorage.removeItem(STORAGE_KEY);
    }
  },
  getters: {
    check: (state, getters, rootState, rootGetters) => (need, type, school) => {
      const needs = need.split('.');
      const theme = rootGetters['theme/getTheme'] || 'membership';
      const schoolId = typeof school === 'object' ? school?.id : school;
      const itemAccess = getSchoolAccess(school, type);
      if (itemAccess && needs.length === 2) {
        return !!itemAccess?.[needs[0]]?.includes(needs[1]);
      }
      if (state.serverAccess?.theme === theme) {
        const schoolAccess = schoolId
          ? state.serverAccess?.schools?.[String(schoolId)]?.[type]
          : null;
        if (schoolAccess && needs.length === 2) {
          return !!schoolAccess?.[needs[0]]?.includes(needs[1]);
        }
        if (hasAccess(state.serverAccess?.global, needs, type)) {
          return true;
        }
      }
      return false;
    }
  },
  actions: {
    async loadAccess({ commit }) {
      const access = await getAccess();
      commit('SET_SERVER_ACCESS', access);
      return access;
    },
    clearAccess({ commit }) {
      commit('SET_SERVER_ACCESS', null);
    }
  },
  state: {
    serverAccess: getStoredAccess()
  }
};
